import { useEffect, useState } from 'react';

export const PHONE_QUERY = '(max-width: 720px), (max-height: 500px) and (max-width: 940px)';

function matches() {
  return typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia(PHONE_QUERY).matches
    : false;
}

export function usePhone() {
  const [phone, setPhone] = useState(matches);

  useEffect(() => {
    const media = window.matchMedia(PHONE_QUERY);
    const apply = () => {
      const next = media.matches;
      setPhone(next);
      document.documentElement.dataset.phone = next ? 'true' : 'false';
    };
    apply();
    media.addEventListener('change', apply);
    return () => media.removeEventListener('change', apply);
  }, []);

  return phone;
}
